// extracted by mini-css-extract-plugin
export var actionButton = "_cp-0";
export var attachmentLine = "_cp-1";
export var fileInput = "_cp-2";
export var fileUploadWrapper = "_cp-4";
export var footer = "_cp-3";
export var modalContent = "_cp-5";
export var paperclip = "_cp-6";
export var quillEditor = "_cp-7";